import React from 'react';
const hunelContext = /*#__PURE__*/React.createContext('');
hunelContext.displayName = 'Hunel';
export default hunelContext;